import { cn } from '@discover-lib/utils';
import Button, { type ButtonProps } from '@discover-ui/button';
import ChevronLeft from '@discover-ui/icons/chevron-left.svg';
import ChevronRight from '@discover-ui/icons/chevron-right.svg';

export type DevMenuButtonProps = {
  visible: boolean;
  setVisible: (newVisible: boolean) => void;
} & Omit<ButtonProps, 'onClick'>;

export default function DevMenuButton({
  visible,
  setVisible,
  kind = 'white-transparent',
  width = 'square',
  className,
  ...props
}: DevMenuButtonProps) {
  return (
    <Button
      kind={kind}
      width={width}
      className={cn('absolute inset-y-0 right-0 rounded-l-none p-1', className)}
      onClick={() => setVisible(!visible)}
      {...props}>
      {visible ? (
        <ChevronLeft width={9} height={9} className="text-blue" />
      ) : (
        <ChevronRight width={9} height={9} className="text-blue" />
      )}
    </Button>
  );
}
